import { Route } from '@angular/router';

export const commissionRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/commission-list.component').then(
        (m) => m.CommissionListComponent
      ),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./detail/commission-detail.component').then(
        (m) => m.CommissionDetailComponent
      ),
  },
];
